<button
  #trigger
  type="button"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  class="core-compact-select__trigger"
  [class.light]="appearance === 'light'"
  [class.md]="size === 'md'"
  [class.is-open]="isOpen"
  [class.has-value]="value"
  [disabled]="disabled"
  [attr.aria-expanded]="isOpen"
  aria-haspopup="listbox"
  (click)="toggle()"
  (keydown)="onKeydown($event)"
>
  <span class="core-compact-select__trigger-label">{{ displayText }}</span>
  <core-ui-icon
    name="chevron"
    size="sm"
    [direction]="isOpen ? 'up' : 'down'"
  ></core-ui-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (attach)="onPanelAttach()"
  (backdropClick)="close(true)"
  (detach)="close()"
>
  <div
    #panelSurface
    class="core-compact-select__panel"
    [class.light]="resolvedPanelAppearance === 'light'"
    [class.sm]="size === 'sm'"
    [class.md]="size === 'md'"
    [class.indicator-right]="optionIndicatorPosition === 'right'"
    role="listbox"
    tabindex="-1"
    (keydown)="onPanelKeydown($event)"
  >
    <button
      #optionButton
      *ngFor="let option of options; let index = index"
      type="button"
      class="core-compact-select__option"
      [class.is-selected]="isSelected(option)"
      [attr.aria-selected]="isSelected(option)"
      role="option"
      (click)="select(option)"
      (keydown)="onOptionKeydown($event, index)"
    >
      <span
        class="core-compact-select__check"
        [class.is-visible]="isSelected(option)"
        aria-hidden="true"
      >
        <core-ui-icon
          name="icon_check"
          [size]="size === 'md' ? 14 : 'sm'"
          [color]="resolvedPanelAppearance === 'light' ? '#1d1d1f' : '#ffffff'"
        ></core-ui-icon>
      </span>
      <span class="core-compact-select__option-label">
        {{ optionLabel(option) }}
      </span>
    </button>
  </div>
</ng-template>
